import { defineComponent as _defineComponent } from 'vue'
import { computed, useSlots } from 'vue';
import { SChipColors } from '@/components/SChipTypes';
import Colors from '@/plugins/colors';
import SEllipsisToolTip from '@/components/SEllipsisTooltip/SEllipsisTooltip.vue';

/**
 *
 * Chips / tags are small visual elements used to label or categorize content.
 *
 */
interface SChipProps {
  /**
   * Icon to display in the chip
   */
  icon?: string;
  /**
   * Standard application colors, for ex. SChipColors.SUCCESS
   */
  color?: SChipColors;
  /**
   * Text to display in the chip
   */
  text: string;
  /**
   * Use `color` for text
   */
  coloredText?: boolean;
  /**
   * Add drop shadow
   */
  elevated?: boolean;
  /**
   * Whether the chip is disabled
   */
  disabled?: boolean;
  /**
   * Fill background with color, text in white, with special case for Neutral
   */
  plain?: boolean;
  /**
   * Whether the chip is emphasized or not, with a bolder darken text color
   */
  emphasize?: boolean;
  /**
   * Whether the chip is downplayed or not, with lighter appearance. Only affects Neutral color.
   */
  downplay?: boolean;
  /**
   * Whether the chip is in a running state or not, with spinner as icon replacement
   */
  running?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SChip',
  props: {
  icon: null,
  color: { default: SChipColors.NEUTRAL },
  text: null,
  coloredText: { type: Boolean },
  elevated: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  plain: { type: Boolean, default: false },
  emphasize: { type: Boolean, default: false },
  downplay: { type: Boolean, default: false },
  running: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;



const textColor = computed((): string => {
  let computedTextColor = 'secondary';
  if (props.plain && props.color !== SChipColors.NEUTRAL) {
    computedTextColor = Colors.shades.white;
  }
  if (props.coloredText) {
    computedTextColor = props.color;
  }
  return computedTextColor;
});

const iconColor = computed((): string => {
  let computedIconColor: string = props.color;
  if (props.plain && props.color !== SChipColors.NEUTRAL) {
    computedIconColor = Colors.shades.white;
  }
  return computedIconColor;
});

const slots = useSlots();
const hasSlot = computed(() => Object.keys(slots).length);

const classList = computed(() => {
  const result = ['schip'];
  if (props.coloredText) {
    result.push('colored-text');
  }
  if (props.elevated) {
    result.push('elevated');
  }
  if (props.plain) {
    result.push('plain');
  }
  if (props.emphasize) {
    result.push('emphasize');
  }
  if (props.downplay) {
    result.push('downplay');
  }
  if (props.icon || props.running || hasSlot.value) {
    result.push('has-icon');
  }
  return result;
});


return { __sfc: true,props, textColor, iconColor, slots, hasSlot, classList, computed, useSlots, SChipColors, Colors, SEllipsisToolTip }
}

})